<template>
  <div class="mb-3" v-if="isShow()">
    <label class="form-label">Картинка</label>
    <input v-if="isShowFileUpload()" type="file" ref="imageRef" class="form-control" placeholder="Картинка" :class="{'is-invalid': fields.validator.image_upload.$invalid && fields.validator.image_upload.$dirty}" @change="onChange"/>
    <div class="invalid-feedback" v-for="error of fields.validator.image_upload.$silentErrors" :key="error.$uid">
      {{ error.$message }}
    </div>
    <div class="image">
      <div v-if="isUpdateAction()">
        <div class="mt-3">
          <template v-if="hasImage()">
            <Lightbox :images="{thumb: getImage(150), origin: getImage(), width: 150}"></Lightbox>
          </template>
          <template v-else>
            <Lightbox :images="{thumb: getImage(150), origin: getImage(), width: 150}"></Lightbox>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {defineComponent, nextTick, onMounted, reactive, ref, watch, toRaw} from "vue"
import Lightbox from "@/components/lightbox/Lightbox"
import CatalogImage from '@/modules/catalog/services/Image'

export default defineComponent({
  name: "Image",
  components: {Lightbox},
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  setup(props, {emit}) {
    let imageRef = ref(null)
    let show = ref(false)
    let showFileUpload = ref(true)

    const fields = reactive({
      validator: {},
      payload: {
        image: {
          host: "",
          name: "",
        },
        image_upload: {},
        is_create: false,
      },
    })

    onMounted(async () => {
      await initFields(props.data)

      enableShow()
    })

    watch(() => props.data, (val) => {
      initFields(val)
    })

    async function initFields(val) {
      fields.validator = val["validator"]
      fields.payload = {
        image: val.payload?.["image"],
        image_upload: val.payload?.["image_upload"],
        is_create: val.payload?.["is_create"]
      }

      let imageUpload = toRaw(val.payload?.["image_upload"])

      if (!(imageUpload instanceof File)) {
        resetInput()
      }
    }

    function enableShow() {
      show.value = true
    }

    function isShow() {
      return show.value === true
    }

    function getImage(w = null, h = null) {
      return [
        CatalogImage.handle(fields.payload.image["host"], fields.payload.image["name"], w, h)
      ]
    }

    function hasImage() {
      return fields.payload.image !== null && fields.payload.image !== undefined && (fields.payload.image["host"] !== "" && fields.payload.image["name"] !== "")
    }

    function isUpdateAction() {
      return fields.payload.is_create !== true
    }

    function onChange(e) {
      const file = e.target.files[0]

      if (file) {
        emit("onUpdate", {
          value: file,
        })
      }
    }

    function resetInput() {
      showFileUpload.value = false
      nextTick(() => {
        showFileUpload.value = true
      })
    }

    function isShowFileUpload() {
      return showFileUpload.value
    }

    return {
      fields,
      getImage,
      hasImage,
      isUpdateAction,
      onChange,
      isShow,
      imageRef,
      isShowFileUpload,
    }
  }
})
</script>

<style scoped src="./css/style.css"></style>
